
import fondo_card from "../../../assets/fonts/fondo_card.svg";
import { loadingOverlay } from "vuetify-more-component";
import CryptoJS from "crypto-js";

import * as XLSX from 'xlsx';

export default {


  components: {
    loadingOverlay,
  },

  data: () => ({
    fondo_card,
    meses: {
      1: "Enero",
      2: "Febrero",
      3: "Marzo",
      4: "Abril",
      5: "Mayo",
      6: "Junio",
      7: "Julio",
      8: "Agosto",
      9: "Septiembre",
      10: "Octubre",
      11: "Noviembre",
      12: "Diciembre"
    },

    items_meses: [],

    loading: false,

    mes_seleccionado: null,

    dialogFacturas: false,

    columnasFacturasRecibidas: [
      {
        text: "Incluye",
        align: "center",
        sortable: true,
        value: "incluye",
      },
      {
        text: "Fecha de emisión",
        align: "center",
        sortable: true,
        value: "fecha_emision",
      },
      {
        text: "Tipo de registro",
        align: "center",
        sortable: true,
        value: "tipo_registro_id",
      },
      {
        text: "Número del DTE",
        align: "center",
        sortable: true,
        value: "numero_dte",
      },
      {
        text: "NIT del emisor",
        align: "center",
        sortable: true,
        value: "nit_emisor",
      },
      {
        text: "Nombre completo del emisor",
        align: "center",
        sortable: true,
        value: "nombre_emisor",
      },
      {
        text: "Moneda",
        align: "center",
        sortable: true,
        value: "moneda",
      },
      {
        text: "Monto (Gran Total)",
        align: "end",
        sortable: true,
        value: "monto",
      },
      {
        text: "Marca de anulado ",
        align: "center",
        sortable: true,
        value: "anulado",
      },
      {
        text: "IVA (monto de este impuesto)",
        align: "center",
        sortable: true,
        value: "monto_iva",
      },

    ],

    facturasRecibidas: [],
    search: '',

    presentacion: null,

    filas_tipo_registro_activos: [],
    filas_tipo_registro_activos_aux: [],


    dialogAlerta: false,
    noMostrar: false,

    items: [],
    select: null,
    usuario : null,

    loading_notificacion: false,
  }),


  computed: {
    size() {
      const size = { xs: "x-small", sm: 'small', md: 'small', lg: 'small', xl: 'small' }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {}
    }
  },


  async created() {
    this.select = parseInt(new Date().getFullYear());
    this.presentacion = null;

    this.getMeses();
    await this.getTipo_registro_listado_activos();

    let anio_auxiliar = new Date().getFullYear();
    // genera 10 años adelante y 10 años atras
    for (let i = 0; i < 4; i++) {
      // this.items.push(anio_auxiliar + i);
      this.items.unshift(anio_auxiliar - i);
    }

    let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
    if (informacion_incriptada != null) {
      let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
      let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
      //Casteo de información a estring
      let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
      //Casteo de JSON String a Object json
      let r = JSON.parse(informacion_desincriptada)
      // console.log("data encriptada");
      // console.log(r);
      this.usuario = r.usuario[0]
      console.log("informacion del usuario");
      console.log(this.usuario);
    }

  },

  methods: {

    convertirnumero(numero) {
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(numero))
    },

    getMeses() {
      this.items_meses = [];
      //obten el año actual
      let anio_actual = parseInt(new Date().getFullYear());

      if (anio_actual == this.select) {
        let mes_actual = new Date().getMonth();
        if (mes_actual == 0) {
          this.items_meses.push({ numero: 12, mes: this.meses[12] });
        } else {
          for (let index = 0; index < mes_actual; index++) {
            this.items_meses.push({ numero: index + 1, mes: this.meses[index + 1] });
          }
          console.log(this.items_meses);
        }
      } else if (anio_actual > this.select) {
        for (let index = 1; index <= 12; index++) {
          this.items_meses.push({ numero: index, mes: this.meses[index] });
        }
      }
      else {
        this.$toast.info("Sin información que mostrar", "Info", {
          timeout: 3000,
          closeable: true,
          position: "top-right",
          icon: "info",
      });
                
      }

    },

    exportarExcel() {

      let data = XLSX.utils.json_to_sheet(this.facturasRecibidas)
      const workbook = XLSX.utils.book_new()
      const filename = 'Facturas Recibidas ' + this.meses[parseInt(this.mes_seleccionado)].toString().toUpperCase() + ' ' + new Date().getFullYear()
      XLSX.utils.book_append_sheet(workbook, data, 'Facturas Recibidas')
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },


    async getTipo_registro_listado_activos() {
      try {
        console.log("llego");
        let r = await this.$store.state.services.administradorService.getTipo_registro_listado_activos();
        console.log("activos", r);
        r.data.data.filter(item => { item.total_sin_iva = 0, item.iva = 0, item.total_con_iva = 0 })
        this.filas_tipo_registro_activos = r.data.data;
        this.filas_tipo_registro_activos_aux = [...r.data.data];

        this.filas_tipo_registro_activos.push({ id: -1, descripcion: "TOTAL", total_sin_iva: 0, iva: 0, total_con_iva: 0 })
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible obtener el listado de regitros activos")
      }
    },

    // marca todas las facturas como incluidas
    marcarTodas() {
      this.facturasRecibidas.forEach(item => {
        if (item.anulado == 0) {
          item.incluye = 1;
        }
      });
      this.calculoDeFacturas();

    },

    // desmarca todas las facturas como incluidas
    desmarcarTodas() {
      this.facturasRecibidas.forEach(item => {
        if (item.anulado == 0) {
          item.incluye = 0;
        }
      });
      this.calculoDeFacturas();

    },
    
    color(item, row) {

      if (row.item.anulado == 1) return;

      if (row.item.incluye == 1) {
        row.item.incluye = 0;
        row.select(false);
        this.calculoDeFacturas();
      } else {

        if (!this.noMostrar) this.dialogAlerta = true;

        row.item.incluye = 1;
        row.select(true);
        this.calculoDeFacturas();
      }
    },

    itemRowBackground: function (item) {
      if (item.anulado == 1) {
        return 'style-3'
      } else {
        return item.incluye === 1 ? 'style-1' : 'style-2'
      }
    },

    async getFacturasUsuario(mes, anio) {
      this.mes_seleccionado = mes;
      this.loading = true;
      console.log("que psa ", this.usuario);
      let r = await this.$store.state.services.usuarioService.getFacturasUsuario(mes, anio, this.usuario.id);
      console.log("getFacturasUsuario", r);
      if (r.data.success) {
        this.loading = false;
        this.dialogFacturas = true;
        this.facturasRecibidas = r.data.data.data;
        this.presentacion = r.data.data.presentacion;
        console.log("facturas recibidas", this.facturasRecibidas);
        this.calculoDeFacturas();
        console.log("calculado");
        console.log("filas activos", this.filas_tipo_registro_activos);
      } else {
        this.loading = false;
        this.$toast.warning("No cuentas con facturas en el mes de " + this.meses[mes] + " del año " + new Date().getFullYear() + ".");
      }
    },

    async postFacturasIncluidas() {
      try {
        this.loading = true;
        console.log(this.facturasRecibidas);
        let r = await this.$store.state.services.usuarioService.postFacturasIncluidas({ facturas: this.facturasRecibidas , presentacion: this.presentacion});
        if (r.data.success) {
          this.loading = false;
          this.$toast.success("Facturas incluidas correctamente.");

        } else {
          this.loading = false;
          this.dialogFacturas = false;
          this.$toast.warning("No cuentas con facturas en el mes de " + this.meses[mes] + " del año " + new Date().getFullYear() + ".");
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("Ha ocurrido un error al intentar incluir las facturas seleccionadas.")
      }
    },

    calculoDeFacturas() {
      /** filtra todos los datos de facturasRecibidas por cada elemento de filas_tipo_registro_activos*/
      this.filas_tipo_registro_activos.forEach(element => {
        // realiza la suma de todos los valores de total_sin_iva de facturasRecibidas que coincidan con el tipo_registro de filas_tipo_registro_activo
        element.total_sin_iva = this.facturasRecibidas.filter(factura => (factura.tipo_registro_id == element.id && factura.anulado == 0 && factura.incluye == 1)).reduce((a, b) => a + b.total_sin_iva, 0);
        // realiza la suma de todos los valores de iva de facturasRecibidas que coincidan con el tipo_registro de filas_tipo_registro_activo
        element.iva = this.facturasRecibidas.filter(factura => (factura.tipo_registro_id == element.id && factura.anulado == 0 && factura.incluye == 1)).reduce((a, b) => a + parseFloat(b.monto_iva), 0);
        // realiza la suma de todos los valores de total_con_iva de facturasRecibidas que coincidan con el tipo_registro de filas_tipo_registro_activo
        element.total_con_iva = parseFloat(element.total_sin_iva + element.iva).toFixed(2);
      });

      // realiza la suma de todas las filas de facturasRecibidas del tipo de registro total_sin_iva
      this.filas_tipo_registro_activos[this.filas_tipo_registro_activos.length - 1].total_sin_iva = this.facturasRecibidas.filter(factura => (factura.anulado == 0 && factura.incluye == 1)).reduce((a, b) => a + b.total_sin_iva, 0);
      // realiza la suma de todas las filas de facturasRecibidas del tipo de registro iva
      this.filas_tipo_registro_activos[this.filas_tipo_registro_activos.length - 1].iva = this.facturasRecibidas.filter(factura => (factura.anulado == 0 && factura.incluye == 1)).reduce((a, b) => a + parseFloat(b.monto_iva), 0);
      // realiza la suma de todas las filas de facturasRecibidas del tipo de registro total_con_iva
      this.filas_tipo_registro_activos[this.filas_tipo_registro_activos.length - 1].total_con_iva = parseFloat(this.filas_tipo_registro_activos[this.filas_tipo_registro_activos.length - 1].total_sin_iva + this.filas_tipo_registro_activos[this.filas_tipo_registro_activos.length - 1].iva).toFixed(2);


    },

    async  confirmar_notificacion_facturas_cliente() {
      console.log("confirmar_notificacion_facturas_cliente");
      console.log("this.usuario", this.usuario);
      console.log("this.presentacion", this.presentacion);
      let body = {
        usuario_id: this.usuario.id,
        presentacion_id: this.presentacion.id,
        empleado: false
      }

      try {
        this.loading_notificacion = true;
        let r = await this.$store.state.services.presentacionService.notificacion_para_seleccion_facturas(body);
        console.log("r", r);
        if(r.data.success){
          this.$toast.success("Notificación enviada correctamente al usuario para que incluya sus facturas");
          this.loading_notificacion = false;
        }else{
          this.$toast.error("No es posible notificar al usuario para que incluya sus facturas")
          this.loading_notificacion = false;
          
        }
        this.loading_notificacion = false;   
      } catch (error) {
        this.loading_notificacion = false;   
        this.$toast.error("No es posible notificar al usuario para que incluya sus facturas")
        console.log(error);
      }
    },

  },


}